<template>
	<ErrorModal
		v-if="show"
		:title="$I18n.trans('commons.error')"
		:body="$I18n.trans('commons.something_went_wrong')"
		@hide="handleHide"
	/>
</template>

<script>
import ErrorModal from '../components/modal/ErrorModal';
import { EVENT, bus } from '@videotools/js/events';

export default {
	name:       'ErrorModalBlock',
	components: { ErrorModal },
	data() {
		return {
			show: false,
		};
	},
	mounted() {
		bus.subscribe(EVENT.NETWORK_SERVER_ERROR, this.showErrorModal);
	},
	destroyed() {
		bus.unsubscribe(EVENT.NETWORK_SERVER_ERROR, this.showErrorModal);
	},
	methods: {
		showErrorModal() {
			this.show = true;
		},
		handleHide() {
			this.show = false;
		},
	},
};
</script>
